  jQuery(document).ready(function($) {
  if ($('body').hasClass('gift-card')) {
    // Hide all the accordions
    $('.product__accordion').hide();
    // Show the last one
    $('.product__accordion').first().show();
    $('.product__accordion').first().css({
      'margin-top': '2.5rem',
      'border-top': '0.1rem solid rgba(var(--color-foreground),.08)'
    });
  }
});